import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { AccountsContextService } from 'src/app/accounts/account-context.service';
import { AccountsService } from 'src/app/accounts/accounts.service';
import { Account } from 'src/app/shared/account/account.types';

export const checkIfAccountExistsOrRedirectOtherwise = (accountType: Account.Type): CanActivateFn => route => {
  const accountsService = inject(AccountsService);
  const accountContextService = inject(AccountsContextService);
  const router = inject(Router);

  const routeContextId: string | undefined = route.params['contextId'];
  const accounts$ = Account.isPublisher(accountType)
    ? accountsService.publishers$
    : accountsService.advertisers$;

  return accounts$.pipe(
    map(list => list.some(item => item.id === routeContextId)),
    map(isAccountAccessible => isAccountAccessible || router.createUrlTree([accountContextService.ACCOUNTS_LIST_URL])),
  )
};

export const updateContextGuard = (accountType: Account.Type): CanActivateFn => route => {
  const accountsContextService = inject(AccountsContextService);
  accountsContextService.updateContextIdIfNeeded(route.params, accountType);

  return accountsContextService.account$
    .pipe(
      map(account => !!account.id),
    );
};
